// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`CreateMisconceptionLessonButton renders correctly 1`] = `<DocumentFragment />`;
